module.exports = __webpack_public_path__ + "img/10.e74a9472.png";